export default "__VITE_ASSET__CeSKa$5D__"